import {useSelector} from 'react-redux';

export default () =>
	useSelector(({reconciliations}) => {
		return reconciliations.selected.componentAccounts;
	});
